import { all, call, select, takeEvery } from 'redux-saga/effects';
import { fetchEntity } from '@classpass/saga-tools';

import { PERMISSION } from 'constants/logic';
import { IA_KEY } from 'helpers/ia-logic';
import { makePath } from 'helpers/link-generation';
import { selectActiveVenue, selectRouteParams, selectIaLogic, selectUserHasPermission } from 'selectors/general';
import { venueClasses } from 'store/saga/entities/bound';
import { ACTIVE_VENUE_CHANGED, waitForAppInit } from 'features/App/App.saga';
import { REDIRECT_HOME, doRedirectHome } from 'features/Home/HomeRedirect.saga';
import { UPDATE_IS_CLASS_ENABLED, doUpdateIsClassEnabled } from '../ClassDetail.saga';

export function* handleClassesRouteEnter(client, action) {
  yield call(waitForAppInit);

  const [activeVenue, routeParams] = yield all([select(selectActiveVenue), select(selectRouteParams)]);
  const venueId = action?.venueId || routeParams?.venueId || activeVenue?.venueId;
  const { featureIsSupported } = yield select(selectIaLogic, IA_KEY.MANAGE_CLASS_PAGES, venueId);
  const includeDisabledClasses = yield select(selectUserHasPermission, PERMISSION.FEATURE_DISABLE_INVENTORY);

  if (!featureIsSupported) {
    return;
  }

  yield all([
    call(fetchEntity, venueClasses, [
      client,
      { venueId, onlyActive: !includeDisabledClasses, includeDisabled: includeDisabledClasses },
    ]),
  ]);
}

export function* handleActiveVenueChange(client, action) {
  const { venueId } = action;
  yield call(client.navigate, makePath.editClass(venueId));
}

export function* watchSchedulesClassesActions(client) {
  yield takeEvery(ACTIVE_VENUE_CHANGED, handleActiveVenueChange, client);
  yield takeEvery(UPDATE_IS_CLASS_ENABLED, doUpdateIsClassEnabled, client);
  yield takeEvery(REDIRECT_HOME, doRedirectHome, client);
}
